/** A special constant with type `never` */
export const NEVER = Object.freeze({
  status: "aborted"
});
export /*@__NO_SIDE_EFFECTS__*/function $constructor(name, initializer, params) {
  var _params$Parent;
  function init(inst, def) {
    var _inst$_zod, _a$traits;
    var _a;
    Object.defineProperty(inst, "_zod", {
      value: (_inst$_zod = inst._zod) !== null && _inst$_zod !== void 0 ? _inst$_zod : {},
      enumerable: false
    });
    (_a$traits = (_a = inst._zod).traits) !== null && _a$traits !== void 0 ? _a$traits : _a.traits = new Set();
    inst._zod.traits.add(name);
    initializer(inst, def);
    // support prototype modifications
    for (const k in _.prototype) {
      if (!(k in inst)) Object.defineProperty(inst, k, {
        value: _.prototype[k].bind(inst)
      });
    }
    inst._zod.constr = _;
    inst._zod.def = def;
  }
  // doesn't work if Parent has a constructor with arguments
  const Parent = (_params$Parent = params === null || params === void 0 ? void 0 : params.Parent) !== null && _params$Parent !== void 0 ? _params$Parent : Object;
  class Definition extends Parent {}
  Object.defineProperty(Definition, "name", {
    value: name
  });
  function _(def) {
    var _a$deferred;
    var _a;
    const inst = params !== null && params !== void 0 && params.Parent ? new Definition() : this;
    init(inst, def);
    (_a$deferred = (_a = inst._zod).deferred) !== null && _a$deferred !== void 0 ? _a$deferred : _a.deferred = [];
    for (const fn of inst._zod.deferred) {
      fn();
    }
    return inst;
  }
  Object.defineProperty(_, "init", {
    value: init
  });
  Object.defineProperty(_, Symbol.hasInstance, {
    value: inst => {
      var _inst$_zod2;
      if (params !== null && params !== void 0 && params.Parent && inst instanceof params.Parent) return true;
      return inst === null || inst === void 0 || (_inst$_zod2 = inst._zod) === null || _inst$_zod2 === void 0 || (_inst$_zod2 = _inst$_zod2.traits) === null || _inst$_zod2 === void 0 ? void 0 : _inst$_zod2.has(name);
    }
  });
  Object.defineProperty(_, "name", {
    value: name
  });
  return _;
}
//////////////////////////////   UTILITIES   ///////////////////////////////////////
export const $brand = Symbol("zod_brand");
export class $ZodAsyncError extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
export class $ZodEncodeError extends Error {
  constructor(name) {
    super("Encountered unidirectional transform during encode: ".concat(name));
    this.name = "ZodEncodeError";
  }
}
export const globalConfig = {};
export function config(newConfig) {
  if (newConfig) Object.assign(globalConfig, newConfig);
  return globalConfig;
}